import { render, staticRenderFns } from "./user_add.vue?vue&type=template&id=553ec208&scoped=true"
import script from "./user_add.vue?vue&type=script&lang=js"
export * from "./user_add.vue?vue&type=script&lang=js"
import style0 from "./user_add.vue?vue&type=style&index=0&id=553ec208&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ec208",
  null
  
)

export default component.exports